import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxConfettiExplosionComponent } from "./ngx-confetti-explosion.component";

@NgModule({
	imports: [CommonModule],
	declarations: [NgxConfettiExplosionComponent],
	exports: [NgxConfettiExplosionComponent]
})
export class NgxConfettiExplosionModule { }

